import { isEmpty } from 'lodash';

import { RouteSequenceApiV4Interface } from '@/types/api-types';

export const getApiOptionFrequency = (option: RouteSequenceApiV4Interface): number => {
  const { segments } = option;
  const perHourArr = segments.reduce((accum, segment) => {
    if ('frequency' in segment) {
      const perHour = segment.frequency?.perHour;
      if (perHour) {
        return [...accum, perHour];
      }
    }
    return accum;
  }, [] as number[]);

  return isEmpty(perHourArr) ? 0 : Math.min(...perHourArr);
};
